import { categories } from '@/mocks/categories';

export default function HeroSection() {
  return (
    <section className="relative w-full min-h-screen flex flex-col bg-background-50">
      <div className="flex-1 flex flex-col lg:flex-row items-center pt-24 md:pt-32 pb-8 px-6 md:px-10">
        <div className="lg:w-3/5 flex flex-col gap-4 md:gap-6">
          <h1 className="font-heading text-5xl md:text-7xl lg:text-8xl font-extrabold text-foreground-950 leading-none tracking-tight">
            CSSBuy<br />
            <span className="text-accent-500">Spreadsheet</span><br />
            2026
          </h1>
          <p className="text-foreground-500 text-base md:text-lg max-w-lg leading-relaxed mt-2">
            O guia mais completo em portugu&ecirc;s para encontrar produtos da China. Spreadsheets atualizados, compara&ccedil;&otilde;es entre agentes e links diretos para voc&ecirc; comprar com seguran&ccedil;a.
          </p>
          <div className="flex flex-col sm:flex-row gap-3 mt-2">
            <a
              href="https://kaspreadsheet.com/"
              target="_blank"
              rel="noopener nofollow"
              className="inline-flex items-center justify-center gap-2 px-6 py-3 rounded-full bg-foreground-950 text-white hover:bg-foreground-800 transition-all text-sm font-semibold cursor-pointer whitespace-nowrap"
            >
              cssbuy spreadsheet
              <i className="ri-arrow-right-up-line"></i>
            </a>
            <a
              href="https://kaspreadsheet.com/"
              target="_blank"
              rel="noopener nofollow"
              className="inline-flex items-center justify-center gap-2 px-6 py-3 rounded-full bg-primary-500 text-white hover:bg-primary-600 transition-all text-sm font-semibold cursor-pointer whitespace-nowrap"
            >
              BUY IT NOW
              <i className="ri-shopping-bag-line"></i>
            </a>
          </div>
          <div className="flex items-center gap-8 mt-4 pt-4 border-t border-background-200">
            <div>
              <span className="font-heading text-3xl font-bold text-foreground-950">15</span>
              <p className="text-xs text-foreground-400">Categorias</p>
            </div>
            <div>
              <span className="font-heading text-3xl font-bold text-foreground-950">10K+</span>
              <p className="text-xs text-foreground-400">Produtos</p>
            </div>
            <div>
              <span className="font-heading text-3xl font-bold text-foreground-950">2026</span>
              <p className="text-xs text-foreground-400">Atualizado</p>
            </div>
          </div>
        </div>

        <div className="lg:w-2/5 mt-8 lg:mt-0 lg:pl-8 flex justify-center">
          <div className="relative w-full max-w-md aspect-[3/4] rounded-3xl overflow-hidden">
            <img
              src="https://readdy.ai/api/search-image?query=Artistic%20flatlay%20composition%20with%20premium%20sneakers%20leather%20backpack%20and%20folded%20denim%20on%20warm%20sandy%20beige%20linen%20surface%20with%20golden%20afternoon%20sunlight%20streaming%20diagonally%20creating%20long%20soft%20shadows%2C%20editorial%20fashion%20photography%2C%20earth%20tone%20color%20palette%2C%20organic%20textures%2C%20minimalist%20yet%20warm%20lifestyle%20aesthetic&width=600&height=800&seq=hero-side-v2-001&orientation=portrait"
              alt="CSSBuy Spreadsheet fashion products"
              className="w-full h-full object-cover object-top"
            />
          </div>
        </div>
      </div>

      <div className="w-full h-[300px] md:h-[420px] relative mt-4">
        <img
          src="https://readdy.ai/api/search-image?query=Overhead%20flatlay%20of%20curated%20streetwear%20collection%20featuring%20colorful%20sneakers%20graphic%20hoodies%20caps%20and%20accessories%20artfully%20arranged%20on%20warm%20terracotta%20linen%20backdrop%20with%20diffused%20morning%20light%20and%20organic%20spacing%2C%20editorial%20catalog%20photography%2C%20vibrant%20yet%20earthy%20tones%2C%20creative%20fashion%20merchandising%20display&width=1800&height=600&seq=hero-banner-v2-002&orientation=landscape"
          alt="CSSBuy Spreadsheet product showcase"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-transparent via-transparent to-background-50"></div>
      </div>
    </section>
  );
}